import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'fal-icons-phone',
  templateUrl: './icons-phone.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconsPhoneComponent {
  @Input() fillColor = 'var(--dhcl-color-primary)';
}
